(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const formSelector = 'form[data-testid="klaviyo-form-VjvAan"]';
  let frameId = null;
  let closeState = null;
  let returnControl = null;
  let generation = 0;

  const getDialog = () => document.querySelector(formSelector)?.closest('[role="dialog"]');
  const isVisible = (element) => {
    if (!element?.isConnected || !element.getClientRects().length || element.closest('[inert], [aria-hidden="true"]')) return false;
    for (let parent = element; parent; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) return false;
    }
    return true;
  };

  const restoreClosedDialog = () => {
    if (!closeState) return;
    const state = closeState;
    closeState = null;
    state.observer.disconnect();
    // Restore only attributes that this helper still owns.
    if (state.dialog.getAttribute('inert') === '') {
      if (state.inert === null) state.dialog.removeAttribute('inert');
      else state.dialog.setAttribute('inert', state.inert);
    }
    if (state.dialog.getAttribute('aria-hidden') === 'true') {
      if (state.ariaHidden === null) state.dialog.removeAttribute('aria-hidden');
      else state.dialog.setAttribute('aria-hidden', state.ariaHidden);
    }
  };

  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.formId !== 'VjvAan') return;
    const dialog = getDialog();
    if (event.detail.type === 'open') {
      generation += 1;
      restoreClosedDialog();
      const active = document.activeElement;
      returnControl = active?.matches?.('button, a[href], input, select, textarea, [role="button"], [tabindex]') && !dialog?.contains(active) ? active : null;
      return;
    }
    if (event.detail.type !== 'close' || !dialog) return;
    if (closeState && closeState.dialog !== dialog) restoreClosedDialog();
    const style = getComputedStyle(dialog);
    // The public close event confirms the lifecycle; opacity alone does not.
    if (style.display !== 'none' && Number(style.opacity) !== 0) return;
    const hadFocus = dialog.contains(document.activeElement);
    const closedGeneration = generation;
    if (style.display !== 'none' && !closeState) {
      const observer = new MutationObserver(() => {
        if (closeState?.dialog === dialog && (!dialog.isConnected || getComputedStyle(dialog).display === 'none')) restoreClosedDialog();
      });
      closeState = { dialog, observer, inert: dialog.getAttribute('inert'), ariaHidden: dialog.getAttribute('aria-hidden') };
      dialog.setAttribute('inert', '');
      dialog.setAttribute('aria-hidden', 'true');
      // Native cleanup releases the guard, even if a later reopen emits no event.
      observer.observe(dialog, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      for (let parent = dialog.parentElement; parent; parent = parent.parentElement) {
        observer.observe(parent, { childList: true });
      }
    }
    if (!hadFocus) return;
    requestAnimationFrame(() => {
      if (generation !== closedGeneration) return;
      const currentStyle = getComputedStyle(dialog);
      if (currentStyle.display !== 'none' && Number(currentStyle.opacity) !== 0) return;
      const active = document.activeElement;
      if (active !== document.body && !dialog.contains(active)) return;
      const teaser = document.querySelector('.kl-teaser-VjvAan [role="button"]');
      for (const target of [returnControl, teaser, document.getElementById('MainContent')]) {
        if (!isVisible(target) || target.matches(':disabled, [aria-disabled="true"]')) continue;
        target.focus({ preventScroll: true });
        if (document.activeElement === target || target.contains(document.activeElement)) break;
      }
    });
  });

  const keepFocusedControlVisible = () => {
    if (!mobile.matches) return;
    const control = document.activeElement;
    const dialog = control?.closest?.('[role="dialog"]');
    if (!dialog?.querySelector(formSelector) || !isVisible(dialog)) return;
    const scroller = dialog.firstElementChild;
    if (!scroller?.contains(control)) return;
    const viewport = window.visualViewport;
    const properties = {
      '--leslis-form-viewport-height': `${viewport?.height ?? window.innerHeight}px`,
      '--leslis-form-viewport-top': `${viewport?.offsetTop ?? 0}px`
    };
    Object.entries(properties).forEach(([name, value]) => {
      if (dialog.style.getPropertyValue(name) !== value) dialog.style.setProperty(name, value);
    });
    const bounds = scroller.getBoundingClientRect();
    const target = control.getBoundingClientRect();
    if (target.bottom > bounds.bottom - 8) scroller.scrollTop += target.bottom - bounds.bottom + 8;
    else if (target.top < bounds.top + 8) scroller.scrollTop -= bounds.top - target.top + 8;
  };

  const schedule = () => {
    if (frameId !== null) return;
    frameId = requestAnimationFrame(() => {
      frameId = null;
      keepFocusedControlVisible();
    });
  };

  document.addEventListener('focusin', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
})();
